import React from 'react'
import { ContentInner } from '../layout/Content'

function HelpInner() {
  return (
    <ContentInner>
      <div className='help-container'>
        <div><b>POS22 1.0.0</b></div>
        <div>by NeonTech Solutions, Inc.</div>
        <div>http://www.pos22.io</div>
      </div>
    </ContentInner>
  )
}

export default React.memo(HelpInner)
